import React, { useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

interface SmallModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: React.ReactNode;
}

export const SmallModal: React.FC<SmallModalProps> = ({
  open,
  onClose,
  title = "Modal Title",
  content,
}) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (open && modalRef.current) {
      modalRef.current.focus();
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="modal-title"
      aria-describedby="modal-content"
    >
      <div ref={modalRef} tabIndex={-1}>
        <DialogTitle id="modal-title">{title}</DialogTitle>
        <DialogContent id="modal-content">{content}</DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
